export const SUPPORT_EMAIL = 'support@cortado.pro'
